export const GITHUB_REPO_URL = 'https://github.com/dmno-dev/dmno';
export const DISCORD_INVITE_URL = 'https://chat.dmno.dev';
